<template>
  <div id="upload-page-error" class="upload-page-state mb-5">
    <div class="flex-grow my-8 px-3">
      <h1>Upload {{ modelName }}</h1>
    </div>
    <vs-row class="card-row" vs-justify="center">
      <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="4">
        <vs-card>
          <div>
            <vs-row vs-justify="center">
              <font-awesome-icon
                  class="my-12 upload-order-check-circle"
                  size="lg"
                  :icon="['far', 'check-circle']"/>
            </vs-row>
            <vs-row vs-justify="center">
              <h1 class="mb-6">
                {{ modelName }} Uploaded
              </h1>
            </vs-row>
            <vs-row vs-justify="center">
              <div class="mb-16 text-center">
                {{ $t('ThankYouForYourSubmission') }}
                <br>
                {{ clientReference }}
              </div>
            </vs-row>
            <vs-row vs-justify="center">
              <div class="mb-16 buttons">
                <vs-button
                    v-if="'enable once we have a work in progress screen' === 1"
                    class="mr-4"
                    @click="$router.push({ name: 'work_in_progress' })"
                    color="light"
                >
                  {{ $t('ViewSubmission') }}
                </vs-button>
                <vs-button
                    @click="$router.back()"
                    color="rgb(213 218 224)"
                    type="border"
                >
                  {{ $t('UploadAnother') }}
                </vs-button>
              </div>
            </vs-row>
          </div>
        </vs-card>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>

export default {
  components: {
  },
  props: {
    modelName: {
      type: String,
      required: true,
    },
  },
  data() {
    return {

    }
  },
  computed: {
    clientReference() {
      return this.$route.params.clientReference;
    }
  },
}
</script>

<style lang="scss">
</style>
